<script>
  //// router : https://gitlab.inria.fr/ink-interaction/list-widgets/-/tree/master/node_modules/svelte-spa-router
  import Router, { location, link } from "svelte-spa-router";
  import Navbar from "../src/components/ihm/NavBar.svelte";
  import NotFound from "./routes/NotFound.svelte";
  import Home from "./routes/Home.svelte";
  import Listeappt from "./routes/ApptListe.svelte";
  import Loyers from "../src/components/LoyersTableau.svelte";
  import EmpruntTab from "./components/EmpruntTab.svelte";
  import CarInfos from "./components/CarInfos.svelte";

  import ListeByBk from "./components/opvcm/ListeByBk.svelte";

  import GraphEdf from "./components/graph/GraphEdf.svelte";
  import GraphCumulByBenef from "./components/graph/GraphCumulByBenef.svelte";
  import GraphTxFronciere from "./components/graph/GraphTxFronciere.svelte";
  import GraphDepensesPerso from "./components/graph/GraphDepensesPerso.svelte";
  import Bank from "./routes/Bank.svelte";

  import HorairesMarees from "./components/HorairesMarees.svelte";
  import Test from "./routes/Test.svelte";

  import Piscine from "./routes/Piscine.svelte";
  import Cocktail from "./components/BouteillesCalcul.svelte";
  import Chrono from "./components/Chrono.svelte";

  import TestCard from "./routes/TestCard.svelte";
  import ListeOpvcm from "./components/opvcm/ListeOpvcm.svelte";
  import ListeTabOpvcm from "./components/opvcm/ListeTabOpvcm.svelte";
  import GrapheOpvcm from "./components/opvcm/GraphBulleOpvcm.svelte";
  import BricksSynthese from "./components/BricksSynthese.svelte"; //"./routes/Test.svelte"

  import RestaurantListe from "./components/RestaurantListe.svelte";
  import RecettesListe from "./components/Recettes/RecettesListe.svelte";
  import RecettesPage from "./components/Recettes/RecettesPage.svelte";
  import Depenses from "./components/DepensesListe.svelte";
  import RecettesPhoto from "./routes/Recettes.svelte";
  import MenuBouttons from "./routes/MenuBouttons.svelte";

  import FilmsListe from "./components/films/FilmsListe.svelte";
  import FilmsPage from "./components/films/FilmsPage.svelte";
</script>

<header>
  <Navbar />
  <br /><br />
</header>

<main id="app">
  <Router
    routes={{
      "/": HorairesMarees,
      // ======== .  APPT ===========
      "/recap": Home,
      "/listeappt": Listeappt,
      "/loyers": Loyers,

      // ======== .  DEPENSES ===========
      "/carsdetail": CarInfos,
      "/depenses": Depenses,
      "/graphdepenses": GraphDepensesPerso,

      // ======== .  OPVCM ===========

      "/listebybk": ListeByBk,
      "/listeopvcm": ListeOpvcm,
      "/listetabopvcm": ListeTabOpvcm,
      "/grapheopvcm": GrapheOpvcm,
      "/brickssynthese": BricksSynthese,

      // ======== .  INFO ===========

      "/graphedf": GraphEdf,
      "/graphtxfronciere": GraphTxFronciere,
      "/bank": Bank,
      "/emprunt/": EmpruntTab,
      "/graphbybenef": GraphCumulByBenef,

      // ======== .  DIVERS ===========
      "/buttons": MenuBouttons,

      "/restau": RestaurantListe,
      "/recettes": RecettesListe,
      "/recette/:id": RecettesPage,
      "/photo": RecettesPhoto,

      "/piscine/": Piscine,

      "/cocktail/": Cocktail,
      "/chrono/": Chrono,

      "/films": FilmsListe,
      "/film/:id": FilmsPage,

      "/test": Test,
      "/testcard": TestCard,

      "*": NotFound,
    }}
  />
</main>
